// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3xcaC","validationTips":"StatementDescriptor_validationTips__21vyQ"};